"use client";
import { j as a } from "./jsx-runtime-CJ-St4mQ.mjs";
import { t as N } from "./tv.config-BuYIgndg.mjs";
import * as d from "react";
import { F as R, u as b } from "./FieldsetRootContext-DS-ONKHT.mjs";
import { u as g } from "./useRenderElement-B8V3_e8R.mjs";
import { u as F } from "./useIsoLayoutEffect-DpJo20by.mjs";
import { u as v } from "./useBaseUiId-a-UPSsPQ.mjs";
const p = /* @__PURE__ */ d.forwardRef(function(e, t) {
  const {
    render: n,
    className: i,
    disabled: s = !1,
    ...m
  } = e, [o, l] = d.useState(void 0), r = d.useMemo(() => ({
    disabled: s
  }), [s]), u = g("fieldset", e, {
    ref: t,
    state: r,
    props: [{
      "aria-labelledby": o
    }, m]
  }), f = d.useMemo(() => ({
    legendId: o,
    setLegendId: l,
    disabled: s
  }), [o, l, s]);
  return /* @__PURE__ */ a.jsx(R.Provider, {
    value: f,
    children: u
  });
});
process.env.NODE_ENV !== "production" && (p.displayName = "FieldsetRoot");
const x = /* @__PURE__ */ d.forwardRef(function(e, t) {
  const {
    render: n,
    className: i,
    id: s,
    ...m
  } = e, {
    disabled: o,
    setLegendId: l
  } = b(), r = v(s);
  F(() => (l(r), () => {
    l(void 0);
  }), [l, r]);
  const u = d.useMemo(() => ({
    disabled: o ?? !1
  }), [o]);
  return g("div", e, {
    state: u,
    ref: t,
    props: [{
      id: r
    }, m]
  });
});
process.env.NODE_ENV !== "production" && (x.displayName = "FieldsetLegend");
const y = N({
  slots: {
    root: "flex w-full flex-col gap-4",
    legend: "border-b border-gray-200 pb-3 text-lg font-medium text-gray-900",
    columns: "grid grid-cols-1 gap-4"
  },
  variants: {
    columns: {
      1: {
        columns: "sm:grid-cols-1"
      },
      2: {
        columns: "sm:grid-cols-2"
      },
      3: {
        columns: "sm:grid-cols-3"
      },
      4: {
        columns: "sm:grid-cols-4"
      },
      5: {
        columns: "sm:grid-cols-5"
      },
      6: {
        columns: "sm:grid-cols-6"
      }
    }
  }
}), {
  root: C,
  legend: E,
  columns: L
} = y(), V = (c) => {
  const { label: e, children: t, columns: n = 1, className: i, ...s } = c;
  return /* @__PURE__ */ a.jsxs(
    p,
    {
      ...s,
      className: C({
        columns: n,
        className: typeof i == "string" ? i : ""
      }),
      children: [
        e && /* @__PURE__ */ a.jsx(x, { className: E(), children: e }),
        n > 1 ? /* @__PURE__ */ a.jsx("div", { className: L({ columns: n }), children: t }) : t
      ]
    }
  );
};
export {
  V as default
};
